import React from 'react';

export default function CardPadding({ style, children }) {
	return <div className="card-padding" style={style}>
		{children}
	</div>;
}